import React from "react";

import UiTooltip from "@/components/Ui/Tooltip";
import UiLabelPlaceholder from "@/components/Ui/Label/Placeholder";
import UiCopy from "@/components/Ui/Copy";

import { SupText } from "@repo/core-ui";
import { twMerge } from "tailwind-merge";
import { shortenString } from "@/utils";

interface GridCellCroppedProps {
  front?: number;
  back?: number;
  value: string;
  showCopy?: boolean;
  showTooltip?: boolean;
  regexp?: RegExp;
  className?: string;
  as?: string;
}

export default function GridCellCropped({ value, showTooltip = true, showCopy = true, front = 2, back = 7, regexp = /https:\/\//g, className, as }: GridCellCroppedProps) {
  return value ? (
    <div className={twMerge("flex select-none items-center gap-2 text-[12px]", className)}>
      <UiTooltip enable={showTooltip} popperClassName="normal-case" content={value}>
        <SupText variant="caption" as={as} className="flex h-full items-center normal-case">
          {shortenString(regexp.test(value) ? value.replace(regexp, "") : value, front, back)}
        </SupText>
      </UiTooltip>
      {showCopy && <UiCopy text={value} />}
    </div>
  ) : (
    <UiLabelPlaceholder>N/A</UiLabelPlaceholder>
  );
}
